import loadable from '@loadable/component';


export default loadable(
  () => import(/* webpackChunkName: "nps.main" */ './Nps'),
);
